import logo from "../assets/servimaxlogo.jpg";
import React from "react";

const Information = ({ nextState }) => {
  return (
    <div className="card">
      <div className="card-header" style={{ background: "red" }}></div>
      <img src={logo} alt="" />
      <p style={{ textAlign: "justify" }}>
        <b>¡Importante!</b>
      </p>
      <p style={{ textAlign: "justify" }}>
        Antes de la captura facial, asegúrate de que se encuentre habilitado la
        cámara de tu celular, además estar en un lugar bien iluminado, con un
        fondo claro. Alinea tu rostro en el recuadro de la pantalla, sin usar
        gafas u otros accesorios que cubran tu rostro.
      </p>
      <p style={{ textAlign: "justify" }}>
        Por tu seguridad y la de tus datos personales, hemos implementado
        medidas para garantizar la privacidad y acceso limitado a los datos
        faciales, utilizándolos solo para fines específicos.
      </p>
      <div className="px-8">
        <button
          className="btn btn-danger follow m-1"
          onClick={() => nextState("SIGNATURE")}
        >
          Atrás
        </button>
        <button
          className="btn btn-secondary follow m-1"
          onClick={() => nextState("SELFIE")}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
};
export default Information;
